import { statusLabels } from "./utils/occurrence-mapping-utils.js";
const OccurrenceMappingCards = ({data}) => {
  return (
    <>
      <div className="grid grid-cols-3 gap-2">
        <div className="text-center">
          <div className="box" id="boxCount">
            <h3>{statusLabels[0]}</h3> <h2>{data?.total_occ ?? 0}</h2>
          </div>
        </div>

        <div className="text-center">
          <div className="box" id="boxCount">
            <h3>{statusLabels[1]}</h3> <h2>{data?.monitoring ?? 0}</h2>
          </div>
        </div>

        <div className="text-center">
          <div className="box" id="boxCount">
            <h3>{statusLabels[2]}</h3> <h2>{data?.alarms ?? 0}</h2>
          </div>
        </div>
      </div>

      <div className="chart-divisor"></div>

    </>
  )
}

export default  OccurrenceMappingCards;